var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
import PassengerCategory from './Model';
export default class default_1 {
    constructor() {
        this.data = [];
        this.loaded = false;
        this.set = (values) => {
            this.data = values.map((item) => new PassengerCategory(item));
            this.loaded = true;
        };
        this.push = (value) => {
            this.data.push(new PassengerCategory(value));
        };
        this.replace = (value) => {
            this.data.splice(this.data.findIndex(f => f.id === value.id), 1, value);
        };
        this.splice = (value) => {
            console.log(value);
            this.data.splice(this.data.findIndex(f => f.id === value), 1);
        };
    }
    read(id) {
        // console.log('PassengerCategorys/Store - read')
        if (id)
            return api.get('passengercategories/' + id);
        return api.get('passengercategories').then((value) => {
            // console.log('value', value)
            this.set(value);
            return value;
        });
    }
    create(value) {
        return api.post('passengercategories', value).then(this.push);
    }
    update(id, value) {
        return api.put('passengercategories/' + id, value).then(this.replace);
    }
    delete(id) {
        return api.delete('passengercategories/' + id).then(this.splice);
    }
}
__decorate([
    observable
], default_1.prototype, "data", void 0);
__decorate([
    observable
], default_1.prototype, "loaded", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);
__decorate([
    action
], default_1.prototype, "push", void 0);
__decorate([
    action
], default_1.prototype, "replace", void 0);
__decorate([
    action
], default_1.prototype, "splice", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/PassengerCategories/Store.ts
// module id = 349
// module chunks = 0